import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { GeckoFields, GECKO_UTILS, GECKO_CONSTS } from 'ui';
import 'react-phone-number-input/style.css';

class WhatsAppChannelForm extends Component {
  static propTypes = {
    value: PropTypes.object,
    onChange: PropTypes.func,
  };
  static defaultProps = {
    onChange: () => {},
  };

  changeHandler(key, value) {
    const newValue = GECKO_UTILS.setNestedValue(this.props.value, key, value);

    this.props.onChange(newValue);
  }

  fields = [
    {
      key: 'display_info',
      type: GECKO_CONSTS.FIELD_TYPE_DISPLAY,
      width: '100%',
      render: () => {
        return (
          <span className="warning">
            <p>
              Currently WhatsApp has an opt-in process, if you are interested in
              this and have not already, please contact support.
            </p>
          </span>
        );
      },
    },
    {
      key: 'name',
      type: GECKO_CONSTS.FIELD_TYPE_TEXT,
      label: 'Channel Title',
      width: 'col-xs-12',
      required: true,
    },
    {
      key: 'configuration.phone_number',
      type: GECKO_CONSTS.FIELD_TYPE_TELEPHONE,
      label: 'Phone Number',
      width: 'col-xs-12',
      required: true,
    },
  ];

  render() {
    return (
      <div className="WhatsAppChannelForm">
        <GeckoFields
          fields={this.fields}
          values={this.props.value}
          handler={this.changeHandler.bind(this)}
        />
      </div>
    );
  }
}

export default WhatsAppChannelForm;
